import React from "react";
import { Link } from "react-router-dom";
import { getImageUrl } from "../../helpers/imageUrl";

const FONT = "'Montserrat', sans-serif";
const CROWN = "/assets/img/home/brand-featured-badge.png";
const PLACEHOLDER = "/assets/img/various/shop-placeholder.jpeg";

/**
 * Featured brand tile (Figma "Zappit Raw Edit" 394:1455): dark glass card with a teal→purple
 * gradient border, the logo in a fixed-size slot (so every brand lines up whatever its image
 * size), the brand name below it, and the crown overlapping the top-right corner.
 */
const FeaturedBrandCard = ({ brand, maxWidth = 72, large = false }) => {
  const name = brand.brand_name || brand.name || "Brand";
  const logoSrc = brand.image ? getImageUrl(brand.image) : PLACEHOLDER;

  return (
    <Link
      to={`/relax/brand/${brand.id}`}
      style={{ width: "100%", maxWidth: `${maxWidth}px`, textDecoration: "none", minWidth: 0 }}
    >
      <div style={{ position: "relative", width: "100%" }}>
        <div
          style={{
            width: "100%",
            aspectRatio: "72 / 76",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: 0,
            position: "relative",
            borderRadius: "10px",
            border: "1px solid transparent",
            background:
              "linear-gradient(160deg, #1b2450 0%, #0d1233 100%) padding-box, linear-gradient(150deg, #9fd8e8 0%, #7c8bd0 55%, #b07ad8 100%) border-box",
            overflow: "hidden",
          }}
        >
          {/* Soft blurred copy of the same image fills the space a wide / tall logo leaves empty,
              so every card looks full whatever the shape of the uploaded image. */}
          <img
            src={logoSrc}
            alt=""
            aria-hidden="true"
            style={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              filter: "blur(10px) saturate(1.1)",
              transform: "scale(1.25)",
              opacity: 0.45,
              pointerEvents: "none",
            }}
            onError={(e) => {
              e.target.style.display = "none";
            }}
          />
          {/* fixed logo slot: same size for every brand; the whole logo is always visible */}
          <div
            style={{
              position: "relative",
              width: "100%",
              height: "100%",
              boxSizing: "border-box",
              padding: "5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={logoSrc}
              alt={name}
              style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain", display: "block", borderRadius: "4px" }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = PLACEHOLDER;
              }}
            />
          </div>
        </div>
        {brand.is_featured !== false && (
          <img
            src={CROWN}
            alt=""
            style={{
              position: "absolute",
              top: "-12px",
              right: "-9px",
              width: "32px",
              height: "21px",
              objectFit: "contain",
              pointerEvents: "none",
            }}
          />
        )}
      </div>
      <div
        style={{
          marginTop: "6px",
          width: "100%",
          textAlign: "center",
          fontFamily: FONT,
          fontSize: large ? "12px" : "11px",
          fontWeight: 500,
          lineHeight: 1.2,
          color: "#e2e2e2",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {name}
      </div>
    </Link>
  );
};

export default FeaturedBrandCard;
